import { axios } from '../../../../services/axios';
import * as CONST from '../../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.CATEGORY_TYPE_CREATE_SUCCESS, categoryType: data.categoryType });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.CATEGORY_TYPE_CREATE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const categoryTypeCreate = (data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.CATEGORY_TYPE_CREATE_REQUEST });

    axios.post('/categories-types', data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
